module.exports = __webpack_public_path__ + "img/company_address.e617e42.png";